import FavouriteButton from "../../components/FavouriteButton.jsx";
import { usd } from "../../../../util/formatCurrency.js";
import { isSoldOut } from "../../components/ProductPage/productAdapter.js";
import s from "./AccessoryCard.module.css";

export default function AccessoryCard({ product, index, onAddToCart }) {
  const soldOut = isSoldOut(product);

  return (
    <article className={s.card} style={{ "--i": index }}>
      <div className={s.frame}>
        {product.product_type && (
          <span className={s.subtitle}>{product.product_type}</span>
        )}
        <div className={s.image}>
          {product.image_url && (
            <img src={product.image_url} alt={product.name} loading="lazy" />
          )}
        </div>
        <div className={s.quickActions}>
          <button
            type="button"
            className={s.quickAdd}
            disabled={soldOut}
            onClick={() => onAddToCart(product)}
          >
            {soldOut
              ? "Sold Out"
              : `Add to Cart \u00b7 ${usd(product._totalPrice)}`}
          </button>
          <div className={s.favWrap}>
            <FavouriteButton productId={product.product_id} variant="dark" />
          </div>
        </div>
      </div>
      <div className={s.body}>
        <h3 className={s.name}>{product.name}</h3>
        <span className={s.price}>{usd(product._totalPrice)}</span>
        <div className={s.sub}>
          {soldOut ? (
            <span className={s.soldOut}>Sold out</span>
          ) : (
            <span>{product.product_type}</span>
          )}
        </div>
      </div>
    </article>
  );
}
